import { observer } from 'mobx-react-lite'
import { Fragment } from 'react'
import { EmptyState, type IRow } from 'shared/ui'
import { Table, TableSearch } from 'shared/ui/TableNew'
import { getCallingActions } from 'pages/chatbot/pages/calling/actions/getCallingActions'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'
import { useCallingContext } from '../context'
import styles from './styles.module.scss'
import { columns } from './colums'
import { type CallingListItem } from '../store/CallingListItem'

export const CallingUI = observer(() => {
  const { search, setSearch, isEmpty, items, tableStore, onSuccessDelete, listLayoutStore } =
    useCallingContext()
  const rows = items.map((item) => {
    item.setActionsProps({
      actions: getCallingActions({
        item: item.origin,
        onSuccessDelete: () => onSuccessDelete(item.id),
      }),
    })

    return item
  })

  const getRowLink = (row: IRow<CallingListItem>) => ChatbotPath.callingView(row.id)

  if (listLayoutStore.isHideChildContent) {
    return null
  }
  return (
    <div className={styles.container}>
      {isEmpty ? (
        <EmptyState variant='default' text='No calling agents' noIcon />
      ) : (
        <>
          <div className={styles.search}>
            <TableSearch value={search} onChange={setSearch} />
          </div>

          <div className={styles.table}>
            <Table
              ariaLabel={tableStore.config.key}
              store={tableStore}
              virtualization
              rows={rows}
              columns={columns}
              pinnedColumnIds={['name']}
              rightHeaderContent={<Fragment />}
              getRowLink={getRowLink}
            />
          </div>
        </>
      )}
    </div>
  )
})
